import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { Images } from "../../../shared/config/images-config";
import { PartialPropertyTaxPay } from '../partial-ptax-pay/partial-ptax-pay.component';
import { MatDialog } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';

enum ARREARS {
  PENDING,
  DUE,
  PROCESSING,
  PAID,
}

interface IProperty {
  ACCT_NO: string;
  OWNER_NAME1: string;
  BILL_ADDRESS: string;
  OWNER_NAME2: string;
  BILL_NAME: string;
  MOBILE: string;
  EMAIL: string;
  PROPERTY_DESC: string;
  TOTAL_RV: string;
  PROPERTY_TYPE: string;
  SECTION: string;
  WARD: string;
  PETH: string;
  DUES: string | number;
}

@Component({
  selector: "app-property-card",
  templateUrl: "./property-card.component.html",
  styleUrls: ["./property-card.component.scss"],
})
export class PropertyCardComponent implements OnInit {
  @Input() data: IProperty;
  @Input() labels;
  @Input() selectedLanguage;
  arrears: typeof ARREARS = ARREARS;
  state: ARREARS = ARREARS.PENDING;
  AppImages: typeof Images = Images;
  @Input() progress: any;

  @Output() viewAction = new EventEmitter();
  @Output() payAction = new EventEmitter();
  @Output() partialPayAction = new EventEmitter();
  partialAnount: any;

  imageBase =
    "https://api.pmccare.in/image/v1/PMC%2Fuser%2FU54381623904889125%2FImage%2Fmoney-icon";
  images = this.AppImages.money;

  // 1. Add Loading Flag
  isNocLoading: boolean = false;

  constructor(private dialog: MatDialog, private http: HttpClient) { }

  ngOnInit() {
  }

  ngAfterViewInit() { }

  getCardState(property: IProperty) {
    const due = Number(property.DUES);

    if (!due) return (this.state = ARREARS.PENDING);
    if (due >= 1) return (this.state = ARREARS.DUE);
    if (due < 1) return (this.state = ARREARS.PAID);
  }

  getIconByState(property: IProperty) {
    if (!property) return this.images.pending;

    const state = this.getCardState(property);

    if (state === this.arrears.DUE) return this.images.due;
    if (state === this.arrears.PAID) return this.images.paid;
    if (state === this.arrears.PENDING) return this.images.pending;
    if (state === this.arrears.PROCESSING) return this.images.processing;
  }

  view(property: IProperty) {
    this.viewAction.emit("view");
  }

  pay(property: IProperty) {
    this.payAction.emit("pay");
  }

  partialPay(property: IProperty) {
    const dialogWidth = window.innerWidth <= 600 ? '90%' : '30%';
    const dialogRef = this.dialog.open(PartialPropertyTaxPay, {
      width: dialogWidth,
      data: { amountDue: parseFloat(property.DUES.toString()) }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.partialAnount = result;
        this.partialPayAction.emit(result);
      }
    });
  }

  // 2. Updated getNoc Method with Loading and Error Handling
  getNoc() {
    if (!this.data || !this.data.ACCT_NO) {
      alert("Property Account Number is missing");
      return;
    }

    // Start Loading
    this.isNocLoading = true;

    const apiUrl = "https://api.digipmc.foxberry.link/user/v1/getPropertyTaxNoc";

    const payload = {
      consumerId: this.data.ACCT_NO
    };

    this.http.post(apiUrl, payload).subscribe(
      (response: any) => {
        // Stop Loading
        this.isNocLoading = false;

        try {
          const nocUrl = response.result.nocUrl.$t;

          if (nocUrl) {
            window.open(nocUrl, '_blank');
          } else {
            alert("Could not retrieve NOC link. Please contact support.");
          }
        } catch (e) {
          console.error("Error processing response", e);
          alert("Error processing NOC data. Please try again.");
        }
      },
      (error) => {
        // Stop Loading on Error
        this.isNocLoading = false;
        console.error("Error calling NOC API", error);
        alert("An error occurred while fetching the NOC. Please check your internet connection.");
      }
    );
  }
}